/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BirthdayInputs */

const en__field_birthday = /** @type {(inputs: _Field_BirthdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birthday`)
};

const de__field_birthday = /** @type {(inputs: _Field_BirthdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtstag`)
};

/**
* | output |
* | --- |
* | "Birthday" |
*
* @param {_Field_BirthdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_birthday = /** @type {((inputs?: _Field_BirthdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BirthdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_birthday(inputs)
	return de__field_birthday(inputs)
});